export default __webpack_public_path__ + "static/media/twiticon.a4156332.svg";